import { useMemo } from 'react';
import { Box, Typography } from '@mui/joy';
import { motion } from 'framer-motion';

// ─── Гифки ─────────────────────────────────────────────────────────────────
// Допиши сюда имена файлов из public/mems_loads/
const GIFS = [
    '/mems_loads/Cat_Kitty_GIF.gif',
    '/mems_loads/Computer_Game_Work_TRT.gif',
    '/mems_loads/Happy_Dance_GIF_by.gif',
    '/mems_loads/Homer_loading_GIF.gif',
    '/mems_loads/Looking_Turn_Around.gif',
    '/mems_loads/No_Brain_Waiting_Sappy_Seals.gif',
    '/mems_loads/Sesame_Street_Waiting_Muppet_Wiki.gif',
    '/mems_loads/Sleepy_Coffee_Time_Pudgy_Penguins.gif',
    '/mems_loads/summer_2016_waiting.gif',
    '/mems_loads/Thinking_Charging.gif',
];

// ─── Подписи под гифкой ────────────────────────────────────────────────────
const MESSAGES = [
    'Котики бегут к вам…',
    'Не уходи, я почти готов 🙏',
    'Кручу шестерёнки…',
    'Грузим мемчики…',
    'Магия в процессе ✨',
    'Подождёшь? Я слегка занят 🐱',
    'Считаем овец… шучу, чеки 📊',
    'Ловим бабочек 🦋',
    'Запрягаем единорогов 🦄',
    'Сейчас-сейчас, дай мне секунду…',
    'Просыпаемся ☕',
    'Перебираем тонну данных вручную',
    'Опять файлики прячутся…',
    'Зовём гнома-помощника 🧙',
];

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export default function MemeLoader({ size = 220, showMessage = true, fullscreen = false }) {
    // useMemo с пустыми deps → гифка/сообщение выбираются один раз на маунт
    const { gif, message } = useMemo(
        () => ({ gif: pick(GIFS), message: pick(MESSAGES) }),
        []
    );

    const content = (
        <Box sx={{
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
            gap: 2,
        }}>
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            >
                <Box
                    component="img"
                    src={gif}
                    alt="loading"
                    onError={(e) => { e.currentTarget.style.display = 'none'; }}
                    sx={{
                        width: size,
                        height: size,
                        objectFit: 'contain',
                        borderRadius: 'var(--joy-radius-xl)',
                        userSelect: 'none',
                        pointerEvents: 'none',
                    }}
                />
            </motion.div>

            {showMessage && (
                <motion.div
                    initial={{ opacity: 0, y: 6 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: 0.1 }}
                >
                    <Typography sx={{
                        fontSize: 13,
                        fontWeight: 600,
                        color: 'var(--joy-palette-text-tertiary)',
                        fontStyle: 'italic',
                        textAlign: 'center',
                        maxWidth: 280,
                    }}>
                        {message}
                    </Typography>
                </motion.div>
            )}
        </Box>
    );

    if (fullscreen) {
        return (
            <Box sx={{
                position: 'fixed', inset: 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                bgcolor: 'var(--joy-palette-background-body)',
                zIndex: 10000,
            }}>
                {content}
            </Box>
        );
    }

    return (
        <Box sx={{
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            py: 6, width: '100%',
        }}>
            {content}
        </Box>
    );
}